// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","MenuItem":"bfz_a bhf_vr bhf_ea bhf_a","MenuItem__Btn":"bfz_b bhf_z"};